module.exports = __webpack_public_path__ + "static/media/webnyay.64069e45.svg";